import { useQuery } from '@tanstack/react-query';
import apiClient from '../api-client';

export type MySquaresSelection = {
  selection: {
    square_number: number | null;
    row_index: number | null;
    col_index: number | null;
    option_id: string;
    prize_amounts_by_period?: Record<string, string>; // Prize amounts won per period: { "Q1": "10.00", "Q2": "5.00", ... }
  };
  contest: {
    status: string;
    start_time_utc?: string;
    row_digits?: number[];
    col_digits?: number[];
    is_game_started: boolean;
    is_live: boolean;
  } | null;
};

type GetMySelectionResponse = MySquaresSelection;

export const getMySelection = (contestId: string) =>
  apiClient.get<GetMySelectionResponse>(`/api/squares/${contestId}/my-selection`);

export const useGetMySelectionQuery = (contestId: string | null) => {
  return useQuery<MySquaresSelection>({
    queryKey: ['squares', 'my-selection', contestId],
    queryFn: () => getMySelection(contestId!),
    enabled: !!contestId,
  });
};
